export const GET_POKEMONS = "GET_POKEMONS";
export const GET_ALL_TYPES = "GET_ALL_TYPES";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const FILTER_CREATED = "FILTER_CREATED";
export const GET_POKEMON_NAME = "GET_POKEMON_NAME";
export const GET_DETAILS = "GET_DETAILS";
export const CLEAN_POKEMONS = "CLEAN_POKEMONS";
export const SORT_POKEMONS = "SORT_POKEMONS";
